export default {
  GroupActivityTrackerSelectContact: {
    mounted() {
      this.el.addEventListener("change", () => {
        const { contactHcpgId } = this.el.dataset;

        // Inform server that a contact has been selected or deselected.
        this.pushEvent("toggle-selected-contact", {
          contact_hcpg_id: contactHcpgId,
        });
      });

      // If user has manually checked all contact checkboxes, check "Select All" checkbox.
      this.handleEvent("select-all-contacts", ({ selectAll }) => {
        // Only check "Select All" checkbox if it differs from the server state.
        const selectAllCheckbox = document.querySelector(
          "#select-all-checkbox",
        );
        if (selectAllCheckbox.checked !== selectAll) {
          selectAllCheckbox.checked = selectAll;
        }
      });
    },
  },
};
